export const environment = {
  production: false,
  // Auth runs against the Foundation Supabase user pool (project zendijuputgqtojpjacz).
  supabase: {
    url: 'https://zendijuputgqtojpjacz.supabase.co',
    anonKey: 'sb_publishable_ndozqth80Rw6dIextzhPvg_aiK7jFkg',
  },
  baseUrl: 'https://billy-backend-dev-new-1078604004638.southamerica-east1.run.app',
  authToken:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJuYW1lIjoiYWJ1ZGFiYSIsImlhdCI6MTY3NTExNTE2OH0.Xcxcz7preBKTU5ROnk8nPO_Mo2WVLStd1AMXyUKZPjY',
};
